(() => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return;

  const rails = [...document.querySelectorAll("[data-scroll-rail]")];
  const texts = [...document.querySelectorAll("[data-scroll-text]")];

  if (!rails.length && !texts.length) return;

  let raf = null;

  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

  const update = () => {
    raf = null;
    const vh = window.innerHeight || document.documentElement.clientHeight;

    // 1) Image rails
    rails.forEach((section) => {
      const track = section.querySelector(".sir__track");
      if (!track) return;

      const rect = section.getBoundingClientRect();
      const total = rect.height - vh;
      if (total <= 0) return;

      // progress 0..1 pendant le "sticky scroll"
      const progress = clamp((-rect.top) / total, 0, 1);

      const distanceVw = parseFloat(getComputedStyle(section).getPropertyValue("--sir-speed")) || 110;
      // de droite -> gauche : on va de +distance à -distance
      const xVw = (1 - progress) * distanceVw - progress * distanceVw;
      track.style.transform = `translate3d(${xVw}vw, 0, 0)`;
    });

    // 2) Text reveal
    texts.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;

        const start = vh * 0.75;     // commence quand la section est bien visible
        const end = vh * 0.25;       // fini avant qu’elle sorte
        const progress = Math.max(0, Math.min(1, (start - rect.top) / (start - end)));

        section.style.setProperty("--reveal", `${(progress * 100).toFixed(2)}%`);
        });

  };

  const onScroll = () => {
    if (raf) return;
    raf = requestAnimationFrame(update);
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  update();
})();
